import { useContext } from 'react';

import { ItemAnalysisContext } from './item-analysis-provider';

function useItemAnalysis() {
  const context = useContext(ItemAnalysisContext);

  if (!context) {
    throw new Error('useItemAnalysis must be used within a ItemAnalysisProvider');
  }

  return context;
}

export { useItemAnalysis };
